export const GETALLQUIZS = "GETALLQUIZS"
export const GETALLQUIZQUESTIONS = "GETALLQUIZQUESTIONS"
export const GETALLREPONSEQUESTIONS = "GETALLREPONSEQUESTIONS"
export const GETONEQUIZ = "GETONEQUIZ"
export const GETMYQUIZS = "GETMYQUIZS"
export const GETQUIZGROUPED = "GETQUIZGROUPED"